import React, { useState } from "react";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import Myproducts from "../pages/Myproducts";
import Addproduct from "../pages/AddProduct";
import { useCookies } from 'react-cookie';
import { useLocation } from "react-router-dom";
import SellerOrders from "../pages/myorders";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Admin = () => {
  const [cookies, setCookie, removeCookie] = useCookies(['token']);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeMenuItem, setActiveMenuItem] = useState("Dashboard");
  const navigate = useNavigate();
  const location = useLocation();


  
  const handleToggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  const handleMenuItemClick = (menuItem) => {
    setActiveMenuItem(menuItem);
  };

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      removeCookie('token'); // Delete the 'token' cookie
      navigate('/login'); // Navigate to the "/" route
    }
  };


  return (
    <section>
      <div style={{ minHeight: "calc(100vh - 70px)" }}>
        <div className="bg-slate-100 flex py-3">
          {isSidebarOpen ? (
            <AiOutlineClose
              onClick={handleToggleSidebar}
              id="menu-con"
              className="mt-2 mr-2 md:hidden"
              size={26}
            />
          ) : (
            <AiOutlineMenu
              onClick={handleToggleSidebar}
              id="menu-con"
              className="mt-2 mr-2 md:hidden"
              size={26}
            />
          )}
          {<h1 className="text-2xl mx-auto font-bold mb-4">Admin_Panel</h1>}
        </div>

        <div className={`flex ${isSidebarOpen ? "flex-col" : "flex-row"}`}>
          {/* Sidebar */}
          <div
            className={`bg-slate-200 p-4 ${
              isSidebarOpen ? "block" : "hidden"
            } md:block`}
          >
            <ul className="space-y-2">
              {/* Dashboard Menu Item */}
              <li
                className={`text-gray-700 font-medium cursor-pointer p-1 ${
                  activeMenuItem === "Dashboard"
                    ? "bg-slate-400 text-white"
                    : ""
                }`}
                onClick={() => handleMenuItemClick("Dashboard")}
              >
                Dashboard
              </li>
              {/* Products Menu Item */}
              <li
                className={`text-gray-700 font-medium cursor-pointer p-1 ${
                  activeMenuItem === "Products" ? "bg-slate-400 text-white" : ""
                }`}
                onClick={() => handleMenuItemClick("Products")}
              >
               Products
              </li>
              {/* Orders Menu Item */}
              <li
                className={`text-gray-700 font-medium cursor-pointer p-1 ${
                  activeMenuItem === "Orders" ? "bg-slate-400 text-white" : ""
                }`}
                onClick={() => handleMenuItemClick("Orders")}
              >
                Orders
              </li>
              {/* Add Products Menu Item */}
              <li
                className={`text-gray-700 font-medium cursor-pointer p-1 ${
                  activeMenuItem === "Add_Products"
                    ? " bg-slate-400 text-white"
                    : ""
                }`}
                onClick={() => handleMenuItemClick("Add_Products")}
              >
                Add_Products
              </li>
              <li onClick={handleLogout}  className={`text-gray-700 font-medium cursor-pointer p-1`}>
                <p>Logout</p>
              </li>
            </ul>
          </div>
          {/* Content */}
          <div
            className={`flex flex-col flex-grow  ${
              isSidebarOpen ? "mt-4" : "ml-0"
            }`}
          >
            <>
              {/* Dashboard Page */}
              {activeMenuItem === "Dashboard" && (
                <div
                  className="h-screen-100 flex justify-center items-center bg-gray-50"
                  style={{ height: "calc(100vh - 100px)" }}
                >
                  <div div className="text-center">
                    <h2 className="text-xl md:text-3xl font-bold mb-4">
                      Welcome to Your Admin Panel
                    </h2>
                    <p className=" text-sm md:text-lg text-gray-600">
                      This is your admin panel. Manage your products, orders,
                      and more from here.
                    </p>
                    <ul className="flex justify-around mt-4">
                        {/* Products Menu Item */}
                        <li
                          className={`text-gray-700 font-medium cursor-pointer p-1 border-2 rounded-xl hover:bg-slate-400 hover:text-white shadow-md ${
                            activeMenuItem === "Products" ? "bg-slate-400 text-white" : ""
                          }`}
                          onClick={() => handleMenuItemClick("Products")}
                        >
                          My_Products
                        </li>
                        {/* Orders Menu Item */}
                        <li
                          className={`text-gray-700 font-medium cursor-pointer p-1 border-2 rounded-xl hover:bg-slate-400 hover:text-white shadow-md ${
                            activeMenuItem === "Orders" ? "bg-slate-400 text-white" : ""
                          }`}
                          onClick={() => handleMenuItemClick("Orders")}
                        >
                          Orders
                        </li>
                        {/* Add Products Menu Item */}
                        <li
                          className={`text-gray-700 font-medium cursor-pointer p-1 border-2 rounded-xl hover:bg-slate-400 hover:text-white shadow-md ${
                            activeMenuItem === "Add_Products" ? "bg-slate-400 text-white" : ""
                          }`}
                          onClick={() => handleMenuItemClick("Add_Products")}
                        >
                          Add_Products
                        </li>
                        {/* Home Menu Item */}
                        <li
                          className={`text-gray-700 font-medium cursor-pointer p-1 border-2 rounded-xl hover:bg-slate-400 hover:text-white shadow-md ${
                            activeMenuItem === "Home" ? "bg-slate-400 text-white" : ""
                          }`}
                          onClick={() => navigate("/")}
                        >
                          Home
                        </li>
                      </ul>

                  </div>
                </div>
              )}
              {/* Add Products Page */}
              {activeMenuItem === "Add_Products" && <Addproduct />}
              {/* Products Page */}
              {activeMenuItem === "Products" && <Myproducts />}
              {/* Orders Page */}
              {/* {activeMenuItem === "Orders" &&  <SellerOrders />} */}
              {activeMenuItem === "Orders" && (
                <div style={{ minHeight: `calc(100vh - 100px)` }} className="overflow-x-auto w-screen md:w-auto mx-auto">
                  <SellerOrders />
                </div>
              )}
            </>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Admin;
